import { gql } from 'graphql-request';
import { LocationFragment, UpdatesFragment } from '../../fragments/fragments';

export const GET_OPERATOR = gql`
  ${UpdatesFragment}
  ${LocationFragment}

  query findCurrentOperators {
    findCurrentOperators {
      id
      name
      description {
        en
        heb
      }
      websiteUrl

      contacts {
        fax
        main
        name
        phone
        mobile
        email
      }
      updatesDetails {
        ...UpdatesFragment
      }
      offerDetails {
        category
        customCategory
        description {
          en
          heb
        }
        id
        location {
          ...LocationFragment
        }
        name
        operatorId
      }

      overviewKpisCategories
    }
  }
`;
